var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "user-view" },
    [
      _vm.user
        ? [
            _c("h1", [_vm._v("User : " + _vm._s(_vm.user.id))]),
            _vm._v(" "),
            _c("ul", { staticClass: "meta" }, [
              _c("li", [
                _c("span", { staticClass: "label" }, [_vm._v("Created:")]),
                _vm._v(
                  " " + _vm._s(_vm._f("timeAgo")(_vm.user.created)) + " ago"
                ),
              ]),
              _vm._v(" "),
              _c("li", [
                _c("span", { staticClass: "label" }, [_vm._v("Karma:")]),
                _vm._v(" " + _vm._s(_vm.user.karma)),
              ]),
              _vm._v(" "),
              _vm.user.about
                ? _c("li", {
                    staticClass: "about",
                    domProps: { innerHTML: _vm._s(_vm.user.about) },
                  })
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "links" }, [
              _c(
                "a",
                {
                  attrs: {
                    href:
                      "https://news.ycombinator.com/submitted?id=" +
                      _vm.user.id,
                  },
                },
                [_vm._v("submissions")]
              ),
              _vm._v(" |\n\t\t\t"),
              _c(
                "a",
                {
                  attrs: {
                    href:
                      "https://news.ycombinator.com/threads?id=" + _vm.user.id,
                  },
                },
                [_vm._v("comments")]
              ),
            ]),
          ]
        : _vm.user === false
        ? [_c("h1", [_vm._v("User not found.")])]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// src/views/UserView.vue